import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.rnf');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-rnf',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.rnf/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.rnf-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: #f8faf9;
}

.rnf-glow {
  position: absolute;
  z-index: -2;
  right: -250px;
  bottom: -330px;
  width: 820px;
  height: 820px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(52, 211, 153, 0.17) 0%, rgba(110, 231, 183, 0.06) 44%, transparent 70%);
  pointer-events: none;
}

.rnf-grid {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.42;
  background-image: linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: linear-gradient(120deg, black, transparent 75%);
  -webkit-mask-image: linear-gradient(120deg, black, transparent 75%);
  pointer-events: none;
}

.rnf-mark {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: #047857;
  border: 1px solid rgba(16, 185, 129, 0.2);
  border-radius: 13px;
  background: rgba(236, 253, 245, 0.9);
  box-shadow: 0 8px 28px rgba(16, 185, 129, 0.08);
}

.rnf-mark span {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.status-ring {
  width: 8px;
  height: 8px;
  border: 2px solid #10b981;
  border-top-color: transparent;
  border-radius: 9999px;
  animation: status-spin 1.6s linear infinite;
}

.symbol-stage {
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.84), rgba(236, 253, 245, 0.28) 46%, transparent 70%);
}

.orbit {
  position: absolute;
  border: 1px solid rgba(16, 185, 129, 0.17);
  border-radius: 9999px;
}

.orbit-outer {
  inset: 3%;
  border-style: dashed;
  animation: orbit-spin 28s linear infinite;
}

.orbit-middle {
  inset: 19%;
  border-color: rgba(100, 116, 139, 0.14);
  animation: orbit-spin 20s linear infinite reverse;
}

.orbit-inner {
  inset: 35%;
  border-color: rgba(16, 185, 129, 0.24);
}

.core-symbol {
  display: grid;
  position: relative;
  z-index: 2;
  width: 112px;
  height: 112px;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  overflow: hidden;
  color: #0f172a;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.11), inset 0 1px 0 rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(16px);
}

.core-symbol span {
  display: flex;
  height: 52px;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  font-weight: 800;
}

.core-symbol span + span {
  border-left: 1px solid rgba(15, 23, 42, 0.08);
}

.node {
  position: absolute;
  width: 9px;
  height: 9px;
  border: 2px solid #f8faf9;
  border-radius: 9999px;
  background: #10b981;
  box-shadow: 0 0 18px rgba(16, 185, 129, 0.45);
}

.node-one {
  top: 8%;
  left: 49%;
}

.node-two {
  right: 17%;
  bottom: 25%;
}

.node-three {
  bottom: 18%;
  left: 19%;
}

@keyframes status-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes orbit-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .status-ring,
  .orbit {
    animation: none;
  }
}`],
})
export class PageRnfComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageRnfComponent;